export default "__VITE_ASSET__CjLNk80x__"